// import React, { useEffect, useState, useRef } from 'react';
// import FileViewer from './FileViewer';
// import LoadingPage from 'shared/loading/LoadingPage';

// const EhrData = ({ ssn, cwOrgId, npi, orgName }) => {
//     const [documents, setDocuments] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [errorMessage, setErrorMessage] = useState('');
//     const hasFetched = useRef(false);

//     const fetchFile = async () => {
//         setLoading(true);
//         setErrorMessage('');

//         const payload = {
//             value: ssn,
//             subjectId: cwOrgId,
//             npi: '12345',
//             orgName: orgName,
//             providerName: "Anu P",
//             status: "current"
//         };

//         try {
//             const response = await fetch(
//                 'https://hc-platform-node-func-prod-03.azurewebsites.net/api/GetPdfAndImage?code=zYcXZaeNh0gb9UOaioV3oiLYf4D7BlNpj7Ca8E4agwrrwKttnqXPow==',
//                 {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify(payload)
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error(`HTTP error! Status: ${response.status}`);
//             }

//             const data = await response.json();
//             const docs = data?.documents || [];

//             if (docs.length > 0) {
//                 const parsedDocs = docs.map((doc, index) => ({
//                     id: index,
//                     base64Data: doc.base64Data,
//                     contentType: doc.contentType
//                 }));
//                 setDocuments(parsedDocs);
//                 setErrorMessage('');
//             } else {
//                 setDocuments([]);
//                 setErrorMessage('No Documents available');
//             }
//         } catch (err) {
//             console.error('Error fetching documents:', err);
//             setDocuments([]);
//             setErrorMessage('No documents available.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (!hasFetched.current) {
//             fetchFile();
//             hasFetched.current = true;
//         }
//     }, []);

//     return (
//         <div style={{ padding: '20px' }}>
//             <h3>EHR Documents</h3>
//             {loading ? (
//                 <LoadingPage />
//             ) : (
//                 <>
//                     {errorMessage && (
//                         <div style={{
//                             width: "100%",
//                             padding: '10px',
//                             margin: '10px 0',
//                             border: '1px solid gainsboro',
//                             borderRadius: '5px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center'
//                         }}>
//                             {errorMessage}
//                         </div>
//                     )}
//                     <div>
//                         {documents.map((doc) => (
//                             <div key={doc.id} style={{ marginBottom: '30px' }}>
//                                 <FileViewer base64Data={doc.base64Data} contentType={doc.contentType} />
//                             </div>
//                         ))}
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// };

// export default EhrData;


// import React, { useEffect, useState, useRef } from 'react';
// import FileViewer from './FileViewer';

// export default function EhrData({ cwOrgId, npi, orgName }) {
//     const [documents, setDocuments] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [errorMessage, setErrorMessage] = useState('');
//     const hasFetched = useRef(false);

//     const fetchFile = async () => {
//         setLoading(true);
//         setErrorMessage('');

//         const payload = {
//             value: '344-68-0123',
//             subjectId: cwOrgId,
//             npi: npi,
//             orgName: orgName,
//             providerName: "Anu P",
//             status: "current"
//         };

//         try {
//             const response = await fetch(
//                 'https://hc-platform-node-func-prod-03.azurewebsites.net/api/GetPdfAndImage?code=zYcXZaeNh0gb9UOaioV3oiLYf4D7BlNpj7Ca8E4agwrrwKttnqXPow==',
//                 {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify(payload)
//                 }
//             );

//             if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//             const data = await response.json();
//             const docs = data?.documents || [];

//             if (docs.length > 0) {
//                 setDocuments(
//                     docs.map((doc, index) => ({
//                         id: index,
//                         base64Data: doc.base64Data,
//                         contentType: doc.contentType
//                     }))
//                 );
//                 setErrorMessage('');
//             } else {
//                 setDocuments([]);
//                 setErrorMessage('No Documents available');
//             }
//         } catch (err) {
//             console.error('Error fetching documents:', err);
//             setDocuments([]);
//             setErrorMessage('No documents available.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (!hasFetched.current) {
//             fetchFile();
//             hasFetched.current = true;
//         }
//     }, []);

//     return (
//         <div style={{ padding: '20px' }}>
//             <h3>EHR Documents</h3>

//             {loading && (
//                 <div style={{ textAlign: 'center', padding: '20px' }}>
//                     <div>Loading documents...</div>
//                 </div>
//             )}

//             {errorMessage && (
//                 <div style={{
//                     width: "100%",
//                     padding: '10px',
//                     margin: '10px 0',
//                     border: '1px solid gainsboro',
//                     borderRadius: '5px',
//                     textAlign: 'center'
//                 }}>
//                     {errorMessage}
//                 </div>
//             )}

//             {!loading && documents.map(doc => (
//                 <div key={doc.id} style={{ marginBottom: '30px' }}>
//                     <FileViewer base64Data={doc.base64Data} contentType={doc.contentType} />
//                 </div>
//             ))}
//         </div>
//     );
// }


// import React, { useEffect, useState, useRef } from 'react';
// import FileViewer from './FileViewer';
// import { Loading } from 'shared';



// export default function EhrData({ ssn,cwOrgId, npi, orgName }) {
//     const [documents, setDocuments] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [errorMessage, setErrorMessage] = useState('');
//     const hasFetched = useRef(false);

//     const fetchFile = async () => {
//         setLoading(true);
//         setErrorMessage('');

//         const payload = {
//             value: ssn,
//             subjectId: cwOrgId,
//             npi: npi,
//             orgName: orgName,
//             providerName: "Anu P",
//             status: "current"
//         };

//         try {
//             const response = await fetch(
//                 'https://hc-platform-node-func-prod-03.azurewebsites.net/api/GetPdfAndImage?code=zYcXZaeNh0gb9UOaioV3oiLYf4D7BlNpj7Ca8E4agwrrwKttnqXPow==',
//                 {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify(payload)
//                 }
//             );

//             if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//             const data = await response.json();
//             const docs = data?.documents || [];

//             if (docs.length > 0) {
//                 setDocuments(
//                     docs.map((doc, index) => ({
//                         id: index,
//                         base64Data: doc.base64Data,
//                         contentType: doc.contentType
//                     }))
//                 );
//                 setErrorMessage('');
//             } else {
//                 setDocuments([]);
//                 setErrorMessage('No Documents available.');
//             }
//         } catch (err) {
//             console.error('Error fetching documents:', err);
//             setDocuments([]);
//             setErrorMessage('No documents available.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (!hasFetched.current) {
//             fetchFile();
//             hasFetched.current = true;
//         }
//     }, []);

//     return (
//         <div>
//             {loading && (
//                 <div style={{ textAlign: 'center', padding: '20px' }}>
//                     <Loading />
//                 </div>
//             )}

//             {errorMessage && (
//                 <div style={{
//                     width: "100%",
//                     padding: '10px',
//                     margin: '10px 0',
//                     borderRadius: '5px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     height: '70vh'
//                 }}>
//                     {errorMessage}
//                 </div>
//             )}

//             {documents.map(doc => (
//                 <div key={doc.id} style={{ marginBottom: '30px' }}>
//                     <FileViewer base64Data={doc.base64Data} contentType={doc.contentType} />
//                 </div>
//             ))}
//         </div>
//     );
// }


// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import FileViewer from './FileViewer';
// import { Loading } from 'shared';
// import {
//     fetchEhrDocuments,
//     clearDocuments
// } from './EhrDocumentSlice';
// export default function EhrData({ ssn, cwOrgId, npi, orgName }) {
//     const dispatch = useDispatch();

//     const documents = useSelector(state => state.ehrDocuments.documents);
//     const loading = useSelector(state => state.ehrDocuments.loading);
//     const error = useSelector(state => state.ehrDocuments.error);

//     const [inputInvalid, setInputInvalid] = useState(false);

//     useEffect(() => {
//         const isValidPayload = ssn && cwOrgId && npi && orgName;
//         if (!isValidPayload) {
//             setInputInvalid(true);
//             return;
//         }

//         setInputInvalid(false);

//         if (documents && documents.length > 0) {
//             return;
//         }

//         if (!loading && !error) {
//             const payload = {
//                 value: ssn,
//                 subjectId: cwOrgId,
//                 npi,
//                 orgName,
//                 providerName: "Anu P",
//                 status: "current"
//             };
//             dispatch(fetchEhrDocuments(payload));
//         }
//     }, [dispatch, ssn, cwOrgId, npi, orgName, documents, loading, error]);

//     const handleRefresh = () => {
//         const isValidPayload = ssn && cwOrgId && npi && orgName;
//         if (!isValidPayload) {
//             setInputInvalid(true);
//             return;
//         }
//         setInputInvalid(false);
//         dispatch(clearDocuments());
//         const payload = {
//             value: ssn,
//             subjectId: cwOrgId,
//             npi,
//             orgName,
//             providerName: "Anu P",
//             status: "current"
//         };
//         dispatch(fetchEhrDocuments(payload));
//     };

//     return (
//         <div>
//             {loading && (
//                 <div style={{ textAlign: 'center', padding: '20px' }}>
//                     <Loading />
//                 </div>
//             )}

//             {inputInvalid && (
//                 <div style={styles.messageBox}>
//                     No Information Available
//                 </div>
//             )}

//             {error && (
//                 <div style={styles.messageBox}>
//                     {error}
//                 </div>
//             )}

//             {(!loading && documents.length === 0 && !error && !inputInvalid) && (
//                 <div style={styles.messageBox}>
//                     No Information Available
//                 </div>
//             )}

//             {documents && documents.map(doc => (
//                 <div key={doc.id} style={{ marginBottom: '30px' }}>
//                     <FileViewer base64Data={doc.base64Data} contentType={doc.contentType} />
//                 </div>
//             ))}

//             {/* Optional Refresh Button */}
//             {/* <div style={{ textAlign: 'center' }}>
//         <button onClick={handleRefresh}>Refresh Documents</button>
//       </div> */}
//         </div>
//     );
// }

// const styles = {
//     messageBox: {
//         width: "100%",
//         padding: '10px',
//         margin: '10px 0',
//         borderRadius: '5px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         height: '70vh'
//     }
// };

// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import FileViewer from './FileViewer';
// import { Loading } from 'shared';
// import { fetchEhrDocuments, clearDocuments } from './EhrDocumentSlice';

// export default function EhrData({ ssn, cwOrgId, npi, orgName }) {
//     const dispatch = useDispatch();

//     const documents = useSelector(state => state.ehrDocuments.documents);
//     const loading = useSelector(state => state.ehrDocuments.loading);
//     const error = useSelector(state => state.ehrDocuments.error);

//     const [inputInvalid, setInputInvalid] = useState(false);
//     const [visibleCount, setVisibleCount] = useState(10); // show first 10 initially

//     useEffect(() => {
//         const isValidPayload = ssn && cwOrgId && npi && orgName;
//         if (!isValidPayload) {
//             setInputInvalid(true);
//             return;
//         }

//         setInputInvalid(false);

//         if (documents && documents.length > 0) return;

//         if (!loading && !error) {
//             const payload = {
//                 value: ssn,
//                 subjectId: cwOrgId,
//                 npi,
//                 orgName,
//                 providerName: "Anu P",
//                 status: "current"
//             };
//             dispatch(fetchEhrDocuments(payload));
//         }
//     }, [dispatch, ssn, cwOrgId, npi, orgName, documents, loading, error]);

//     const handleRefresh = () => {
//         const isValidPayload = ssn && cwOrgId && npi && orgName;
//         if (!isValidPayload) {
//             setInputInvalid(true);
//             return;
//         }
//         setInputInvalid(false);
//         dispatch(clearDocuments());
//         const payload = {
//             value: ssn,
//             subjectId: cwOrgId,
//             npi,
//             orgName,
//             providerName: "Anu P",
//             status: "current"
//         };
//         dispatch(fetchEhrDocuments(payload));
//     };

//     const handleViewMore = () => {
//         setVisibleCount(prev => prev + 10);
//     };

//     const visibleDocuments = documents.slice(0, visibleCount);

//     return (
//         <div>
//             {loading && (
//                 <div style={{ textAlign: 'center', padding: '20px' }}>
//                     <Loading />
//                 </div>
//             )}

//             {inputInvalid && (
//                 <div style={styles.messageBox}>No Information Available</div>
//             )}

//             {error && (
//                 <div style={styles.messageBox}>{error}</div>
//             )}

//             {(!loading && documents.length === 0 && !error && !inputInvalid) && (
//                 <div style={styles.messageBox}>No Information Available</div>
//             )}

//             {visibleDocuments.map(doc => (
//                 <div key={doc.id} style={{ marginBottom: '30px' }}>
//                     <FileViewer
//                         base64Data={doc.base64Data}
//                         contentType={doc.contentType}
//                     />
//                 </div>
//             ))}

//             {/* “View More” Button */}
//             {visibleCount < documents.length && (
//                 <div style={{ textAlign: 'center', marginTop: '20px' }}>
//                     <button
//                         type='button'
//                         onClick={handleViewMore}
//                         style={{
//                             padding: '10px 20px',
//                             backgroundColor: '#007bff',
//                             color: '#fff',
//                             border: 'none',
//                             borderRadius: '6px',
//                             cursor: 'pointer'
//                         }}
//                     >
//                         View More ({documents.length - visibleCount} Remaining)
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// }

// const styles = {
//     messageBox: {
//         width: '100%',
//         padding: '10px',
//         margin: '10px 0',
//         borderRadius: '5px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         height: '70vh'
//     }
// };


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FileViewer from './FileViewer';
import { Loading } from 'shared';
import { fetchEhrDocuments, clearDocuments } from './EhrDocumentSlice';

export default function EhrData({ ssn, cwOrgId, npi, orgName }) {
    const dispatch = useDispatch();

    const documents = useSelector(state => state.ehrDocuments.documents);
    const loading = useSelector(state => state.ehrDocuments.loading);
    const error = useSelector(state => state.ehrDocuments.error);

    const [inputInvalid, setInputInvalid] = useState(false);

    const PAGE_SIZE = 10;
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const isValidPayload = ssn && cwOrgId && npi && orgName;

        if (!isValidPayload) {
            setInputInvalid(true);
            return;
        }

        setInputInvalid(false);

        if (documents && documents.length > 0) return;

        if (!loading && !error) {
            setCurrentPage(1);
            const payload = {
                value: ssn,
                subjectId: cwOrgId,
                npi,
                orgName,
                providerName: 'Anu P',
                status: 'current'
            };
            dispatch(fetchEhrDocuments(payload));
        }
    }, [dispatch, ssn, cwOrgId, npi, orgName, documents, loading, error]);


    const handleRefresh = () => {
        const isValidPayload = ssn && cwOrgId && npi && orgName;

        if (!isValidPayload) {
            setInputInvalid(true);
            return;
        }

        setInputInvalid(false);
        setCurrentPage(1);
        dispatch(clearDocuments());

        const payload = {
            value: ssn,
            subjectId: cwOrgId,
            npi,
            orgName,
            providerName: 'Anu P',
            status: 'current'
        };

        dispatch(fetchEhrDocuments(payload));
    };

    const totalPages = Math.ceil(documents.length / PAGE_SIZE);
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    const endIndex = startIndex + PAGE_SIZE;
    const visibleDocuments = documents.slice(startIndex, endIndex);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    };

    return (
        <div>
            {loading && (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Loading />
                </div>
            )}

            {inputInvalid && (
                <div style={styles.messageBox}>No Information Available</div>
            )}

            {error && (
                <div style={styles.messageBox}>{error}</div>
            )}

            {!loading && documents.length === 0 && !error && !inputInvalid && (
                <div style={styles.messageBox}>No Information Available</div>
            )}

            {visibleDocuments.map(doc => (
                <div key={doc.id} style={{ marginBottom: '30px' }}>
                    <FileViewer
                        base64Data={doc.base64Data}
                        contentType={doc.contentType}
                    />
                </div>
            ))}

            {documents.length > PAGE_SIZE && (
                <div style={styles.pagination}>
                    <button
                        type="button"
                        onClick={handlePrevPage}
                        disabled={currentPage === 1}
                        style={styles.pageButton}
                    >
                        Previous
                    </button>

                    <span style={styles.pageText}>
                        Page {currentPage} of {totalPages}
                    </span>

                    <button
                        type="button"
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                        style={styles.pageButton}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
}

const styles = {
    messageBox: {
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '70vh'
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        marginTop: '20px'
    },
    pageButton: {
        padding: '8px 16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        cursor: 'pointer'
    },
    pageText: {
        fontWeight: 500
    }
};

